module.exports = __webpack_public_path__ + "static/media/img31.74c7ce69.gif";